import { createDemoRepository, generateMemoryUniverse, type GeneratorOptions } from './generate'
import { createMemoryRepository } from './repository'
import type { ArtifactFilters, MemoryArtifact, MemoryRepository, MemoryUniverse } from './types'

export { createDemoRepository, generateMemoryUniverse, type GeneratorOptions } from './generate'
export { createMemoryRepository } from './repository'

/** Compatibility-first entry points for the application data layer. */
export const createDemoUniverse = (options: GeneratorOptions = {}): MemoryUniverse => generateMemoryUniverse(options)
export const createUniverseIndex = (universe: MemoryUniverse): MemoryRepository => createMemoryRepository(universe)
export const searchArtifacts = (
  universe: MemoryUniverse,
  index: MemoryRepository,
  query: string,
  limit = 50,
): MemoryArtifact[] => {
  if (index.universe !== universe) return createMemoryRepository(universe).search(query).slice(0, limit)
  return index.search(query).slice(0, limit)
}
export const filterArtifacts = (universe: MemoryUniverse, filters: ArtifactFilters = {}): MemoryArtifact[] =>
  createMemoryRepository(universe).filterArtifacts(filters)
export {
  ARTIFACT_TYPES,
  RELATION_TYPES,
  type ArtifactFilters,
  type ArtifactType,
  type Cluster,
  type MemoryArtifact,
  type MemoryEvent,
  type MemoryRelation,
  type MemoryRepository,
  type MemoryUniverse,
  type Position3D,
  type Project,
  type RelationType,
} from './types'
